import { get, post, put, remove } from './api';
import {
  ApproveTicketRequestBodyDTO,
  ChangeTicketClaimStatusRequestBodyDTO,
  ChangeTicketDetailsRequestBodyDTO,
  ChangeTicketPriorityRequestBodyDTO,
  ChangeTicketsReadStatusRequestBodyDTO,
  CloseTicketRequestBodyDTO,
  CreateTicketAttachmentRequestBodyDTO,
  CreateTicketMessageRequestBodyDTO,
  CreateTicketMultiPartAttachmentCompleteRequestBodyDTO,
  CreateTicketMultiPartAttachmentInitiateRequestBodyDTO,
  CreateTicketMultiPartAttachmentInitiateResponseBodyDTO,
  CreateTicketMultiPartAttachmentUploadRequestBodyDTO,
  CreateTicketMultiPartAttachmentUploadResponseBodyDTO,
  CreateTicketRequestBodyDTO,
  CreateTicketScreenshotMessageRequestBodyDTO,
  ExportTicketsRequestDTO,
  GetTicketAttachmentsResponseDTO,
  GetTicketMessagesResponseDTO,
  GetTicketResponseDTO,
  GetTicketsCountByRoofTopResponseDTO,
  GetTicketsCountByRooftopsParamsDTO,
  GetTicketsRequestParamsDTO,
  GetTicketsResponseDTO,
  ReopenTicketRequestBodyDTO,
} from 'declarations/dto/tickets';

export const getTicketsApi = async (params?: GetTicketsRequestParamsDTO) => {
  const response = await get<GetTicketsResponseDTO>(`/tickets`, params);

  return response.data;
};

export const getTicketApi = async (ticketId: string) => {
  const response = await get<GetTicketResponseDTO>(`/tickets/${ticketId}/details`);

  return response.data;
};

export const getTicketsCountByRoofTopApi = async (params: GetTicketsCountByRooftopsParamsDTO) => {
  const response = await get<GetTicketsCountByRoofTopResponseDTO>(
    `/tickets/count-by-rooftop`,
    params
  );

  return response.data;
};

export const createTicketApi = async (data: CreateTicketRequestBodyDTO) => {
  const response = await post<void>(`/tickets/by-dealer`, data);

  return response.data;
};

export const reopenTicketApi = async (data: ReopenTicketRequestBodyDTO) => {
  const response = await post<void>(`/tickets/reopen`, data);

  return response.data;
};

export const approveTicketApi = async (data: ApproveTicketRequestBodyDTO) => {
  const response = await post<void>(`/tickets/approve`, data);

  return response.data;
};

export const closeTicketApi = async (data: CloseTicketRequestBodyDTO) => {
  const response = await post<void>(`/tickets/close`, data);

  return response.data;
};

export const createTicketMessageApi = async (
  ticketId: string,
  data: CreateTicketMessageRequestBodyDTO
) => {
  const response = await post<void>(`/tickets/${ticketId}/text-messages`, data);

  return response.data;
};

export const createTicketAttachmentApi = async (
  ticketId: string,
  data: CreateTicketAttachmentRequestBodyDTO
) => {
  const response = await post<void>(`/tickets/${ticketId}/attachments`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
};

export const createTicketMultiAttachmentApi = async (
  ticketId: string,
  data: CreateTicketAttachmentRequestBodyDTO[]
) => {
  const response = await post<void>(`/tickets/${ticketId}/attachments`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
};
export const createScreenshotMessageApi = async (
  ticketId: string,
  data: CreateTicketScreenshotMessageRequestBodyDTO
) => {
  const response = await post<void>(`/tickets/${ticketId}/screenshots`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
};

export const getTicketAttachmentsApi = async (ticketId: string) => {
  const response = await get<GetTicketAttachmentsResponseDTO>(`/tickets/${ticketId}/attachments`);

  return response.data;
};

export const getTicketMessagesApi = async (ticketId: string) => {
  const response = await get<GetTicketMessagesResponseDTO>(`/tickets/${ticketId}/messages`);

  return response.data;
};

export const changeTicketClaimStatusApi = async (data: ChangeTicketClaimStatusRequestBodyDTO) => {
  const response = await put<void>(
    `/tickets/${data.ticketId}/claim-status/${data.claimStatusId}`,
    data
  );

  return response.data;
};

export const changeTicketPriorityApi = async (data: ChangeTicketPriorityRequestBodyDTO) => {
  const response = await put<void>(
    `/tickets/${data.ticketId}/priorities/${data.ticketPriorityId}`,
    data
  );

  return response.data;
};

export const changeTicketDetailsApi = async (data: ChangeTicketDetailsRequestBodyDTO) => {
  const response = await put<void>(`/tickets/${data.ticketId}`, data);

  return response.data;
};

export const markTicketsAsReadApi = async (data: ChangeTicketsReadStatusRequestBodyDTO) => {
  const response = await post<void>(`/tickets/mark-read`, data);

  return response.data;
};

export const markTicketsAsUnReadApi = async (data: ChangeTicketsReadStatusRequestBodyDTO) => {
  const response = await post<void>(`/tickets/mark-unread`, data);

  return response.data;
};

export const deleteTicketApi = async (ticketId: string) => {
  const response = await remove<void>(`/tickets/${ticketId}`);

  return response.data;
};

export const createTicketMultiPartAttachmentInitiateApi = async (
  ticketId: string,
  data: CreateTicketMultiPartAttachmentInitiateRequestBodyDTO
) => {
  const response = await post<CreateTicketMultiPartAttachmentInitiateResponseBodyDTO>(
    `/tickets/${ticketId}/attachments/multi-part/initiate`,
    data
  );

  return response.data;
};

export const createTicketMultiPartAttachmentUploadApi = async (
  data: CreateTicketMultiPartAttachmentUploadRequestBodyDTO
) => {
  const response = await post<CreateTicketMultiPartAttachmentUploadResponseBodyDTO>(
    `/tickets/attachments/multi-part/upload`,
    data
  );

  return response.data;
};

export const createTicketMultiPartAttachmentCompleteApi = async (
  ticketId: string,
  data: CreateTicketMultiPartAttachmentCompleteRequestBodyDTO
) => {
  const response = await post<void>(`/tickets/${ticketId}/attachments/multi-part/complete`, data);

  return response.data;
};

export const exportTicketsApi = async (body: ExportTicketsRequestDTO) => {
  const response = await post<Blob>(`/tickets/export`, body, {
    responseType: 'blob',
  });

  return response.data;
};
